import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

import { environment } from '../../../../environments/environment';
import { APP_VERSION } from '../../app-version';
import { AyudaSeccion } from '../../help/ayuda-contenido';
import { LegalDialogComponent, LegalSection } from '../legal-dialog/legal-dialog.component';

@Component({
  standalone: true,
  selector: 'app-ayuda-dialog',
  imports: [CommonModule, MatDialogModule, MatIconModule, MatButtonModule],
  templateUrl: './ayuda-dialog.component.html',
  styleUrls: ['./ayuda-dialog.component.scss'],
})
export class AyudaDialogComponent {
  readonly marca = environment.marca;
  readonly appVersion = APP_VERSION;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AyudaSeccion,
    private dialog: MatDialog
  ) {}

  openLegal(section: LegalSection): void {
    this.dialog.open(LegalDialogComponent, {
      data: { section },
      width: '720px',
      maxWidth: '96vw',
      maxHeight: '90vh',
    });
  }
}
